import PdfViwer from "./PdfViwer";

export default {
    PdfViwer,
}